export const data = {
  episode: 2,
  title: "Specialties of Prophet Muhammad SAW (Part 2)",
  video: "https://www.youtube.com/watch?v=udjM4dBVicE",
};
